import React, {ReactNode} from 'react';

import {Typography} from '@mui/material';

import {useActions} from './useActions';

import './styles';

export interface CarouselItemImageProps {
  source?: string;
  width?: React.ImgHTMLAttributes<HTMLImageElement>['width'];
  height?: number;
}

export interface CarouselItemDescriptionProps {
  text: ReactNode;
  icon?: ReactNode;
}

export interface CarouselItemProps {
  id?: string;
  title?: string;
  descriptionList?: CarouselItemDescriptionProps[];
  note?: ReactNode;
  image?: CarouselItemImageProps;
  trackEvent?: () => void;
}

export const CarouselItem: React.FC<CarouselItemProps> = ({
  image,
  title,
  descriptionList,
  note,
}: CarouselItemProps) => {
  const {descriptionClassName} = useActions({descriptionList});

  return (
    <section className="carousel-item-container">
      {image?.source && (
        <section className="carousel-card-image">
          <img
            src={image.source}
            width={image.width ?? 'auto'}
            height={image.height ?? 'auto'}
            alt="card"
          />
        </section>
      )}
      {title && descriptionList && (
        <section className="carousel-item-text-content">
          {title && (
            <Typography className="carousel-item-title">{title}</Typography>
          )}
          {descriptionList && (
            <>
              {descriptionList?.map((description, index) => {
                return (
                  <section
                    key={`carousel-item-${index}`}
                    className="carousel-item-description-content">
                    {description.icon && description.icon}

                    <Typography className={descriptionClassName}>
                      {description.text}
                    </Typography>
                  </section>
                );
              })}
            </>
          )}

          {note && (
            <Typography className="carousel-item-note">{note}</Typography>
          )}
        </section>
      )}
    </section>
  );
};
